const UNKNOWN_CONSTANT = "UNKNOWN"
export var AppName
;(function (AppName) {
  AppName["JJXT"] = "jjxt"
  AppName["HXKT"] = "hxkt"
  AppName["SPT"] = "spt"
  AppName["AQM"] = "aqm"
  AppName["UNKNOWN"] = "UNKNOWN"
})(AppName || (AppName = {}))
export var Platform
;(function (Platform) {
  Platform["H5"] = "H5"
  Platform["MINIPROGRAM"] = "MINIPROGRAM"
  Platform["APP"] = "APP"
})(Platform || (Platform = {}))
export var OS
;(function (OS) {
  OS["IOS"] = "IOS"
  OS["ANDROID"] = "ANDROID"
  OS["HARMONY"] = "HARMONY"
  OS["UNKNOWN"] = "UNKNOWN"
})(OS || (OS = {}))
// 正则集和匹配
const Regexs = {
  version: /\d+(?:\.\d+){1,3}/,
  harmony: /OpenHarmony (\d+(?:\.\d+)*)/i,
  ios: /(iPad|iPhone); CPU (?:iPhone )?OS (\d+(?:_\d+)*)/i,
  android: /Linux; Android (\d+(?:\.\d+)*)/, // Android
}
export const getAppNameInWebView = () => {
  const matchResult = navigator.userAgent
    .toLowerCase()
    .match(/jjxt|hxkt|spt|aqm/i)
  if (matchResult && matchResult.length > 0) {
    const matchedApp = matchResult[0]
    return AppName[matchedApp.toUpperCase()] || ""
  }
  return AppName.UNKNOWN
}
export const getAppVersionInWebView = (appName) => {
  const versionRegex = Regexs.version
  let versionStr = ""
  const UaArrData = navigator.userAgent
    .toLowerCase()
    .split(appName.toLocaleLowerCase())
  if (UaArrData.length > 1) {
    // versionStr 是UaArrData 第2个元素到后面的综合
    versionStr = UaArrData.slice(1).join("")
  }
  if (versionStr) {
    const match = versionStr.match(versionRegex)
    return match ? match[0] : UNKNOWN_CONSTANT
  }
  return UNKNOWN_CONSTANT
}
export const getOsVersionByUserAgent = (os) => {
  if (os === OS.IOS) {
    const match = navigator.userAgent.match(Regexs.ios)
    if (match) {
      const version = match[2].replace(/_/g, ".") // 17_5_1 → 17.5.1
      return version
    }
  } else if (os === OS.ANDROID) {
    const result = Regexs.android.exec(navigator.userAgent)
    if (result && result.length > 1) {
      return result[1]
    }
  } else if (os === OS.HARMONY) {
    // 纯血鸿蒙才有 hanmony 标识, 旧版的没有, 还是android, 因此暂时不管鸿蒙
    const result = Regexs.harmony.exec(navigator.userAgent)
    if (result && result.length > 1) {
      return result[1]
    }
  }
  return UNKNOWN_CONSTANT
}
// 旧版的鸿蒙是android 10 , 不会识别为鸿蒙
// 通过 userAgent 来判断当前环境的应用名称、平台类型、操作系统类型和版本
// 目前支持的应用名称有：JJXT、HXKT、SPT、AQM
// 平台类型包括：H5、MINIPROGRAM、APP
// 操作系统类型包括：IOS、ANDROID、HARMONY、UNKNOWN
// 返回一个对象，包含应用名称、平台类型、操作系统类型、应用版本号
// 和操作系统版本
// 注意：如果无法识别应用名称，则返回 UNKNOWN
// 注意：如果无法识别平台类型，则默认返回 H5
// 注意：如果无法识别操作系统类型，则默认返回 UNKNOWN
// 注意：如果无法识别应用版本号，则返回 UNKNOWN
// 注意：如果无法识别操作系统版本，则返回 UNKNOWN
// 注意：如果是小程序，则平台类型为 MINIPROGRAM
// 注意：如果是 APP，则平台类型为 APP
// 注意：如果是 H5，则平台类型为 H5
// 注意：如果是鸿蒙，则操作系统类型为 HARMONY
// 注意：如果是 iOS，则操作系统类型为 IOS
// 注意：如果是 Android，则操作系统类型为 ANDROID
// 注意：如果是未知操作系统，则操作系统类型为 UNKNOWN
// 注意：如果是未知应用名称，则应用名称为 UNKNOWN
export const detectEnvironmentMetadata = () => {
  const appName = getAppNameInWebView()
  let platform = Platform.H5
  let os = OS.UNKNOWN
  let version = "UNKNOWN"
  if (
    window.navigator.userAgent.toUpperCase().includes("IPHONE") ||
    window.navigator.userAgent.toUpperCase().includes("IPAD")
  ) {
    os = OS.IOS
  } else if (window.navigator.userAgent.toUpperCase().includes("ANDROID")) {
    os = OS.ANDROID
  } else if (window.navigator.userAgent.toUpperCase().includes("HARMONY")) {
    os = OS.HARMONY
  }
  if (appName !== AppName.UNKNOWN) {
    platform = Platform.APP
    version = getAppVersionInWebView(appName)
  }
  if (window.navigator.userAgent.includes("miniProgram")) {
    platform = Platform.MINIPROGRAM
  }
  let osVersion = getOsVersionByUserAgent(os)
  // 补全版本的位数
  if (osVersion !== UNKNOWN_CONSTANT && osVersion.split(".").length < 3) {
    osVersion = osVersion.split(".").concat(["0", "0"]).slice(0, 3).join(".")
  }
  return {
    appName,
    platform,
    os,
    version,
    osVersion,
    IS_HX: appName === AppName.HXKT || appName === AppName.JJXT, // 是否是嗨学, 嗨学课堂和精进学堂都属于嗨学业务线
  }
}
